import { Box, Button, IconButton, Typography, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import axiosInstance from "../AxiosBaseApi";

const DailyStatemant = () => {
  const navigate = useNavigate();
  const [data, SetData] = useState([]);
  const [activeTab, setActiveTab] = useState("invitereward"); // State to track the active tab ('revenue' or 'expenditure')
  const [loading, setLoading] = useState(false); // State to track if data is being fetched

  // Modify the getUserData function to handle both "revenue" and "expenditure"
  const getUserData = async (uid, type) => {
    setLoading(true); // Start loading
    try {
      let endpoint = ""; 
      if (type === "invitereward") {
        // Revenue API
        endpoint = `/bet.php?action=invitereward&user=${uid}&level=C`;
      } else if (type === "expenditure") {
        // Expenditure API
        endpoint = `/bet.php?action=transrecord&user=${uid}`;
      }

      const response = await axiosInstance.get(endpoint);
      if (response.status === 200) {
        SetData(response.data);
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.log("Error", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  // Fetch the data when the component mounts or the activeTab changes
  useEffect(() => {
    const token = localStorage.getItem("mamberId");
    if (!token) {
      navigate("/login");
    } else {
      getUserData(token, activeTab); // Fetch data based on the active tab
    }
  }, [activeTab]); // Effect triggers when the active tab changes

  return (
    <>
      <div style={{ width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            padding: 1,
            justifyContent: "space-between",
            alignItems: "center",
            background: "#3d3b6f",
          }}
        >
          <Box onClick={() => navigate(-1)} style={{ textDecoration: "none" }}>
            <ChevronLeftIcon
              fontSize="medium"
              style={{
                color: "#fff",
                border: "1px solid #f2f3f5",
                borderRadius: 50,
              }}
            />
          </Box>
          <Typography variant="subtitle2" color="#fff">
            Funding details
          </Typography>
          <Box />
        </Box>

        <Box display="flex" justifyContent="center" mt={2}>
          <Button
            style={{
              width: "45%",
              borderRadius: 0,
              fontSize: "14px",
              fontWeight: "700",
              backgroundColor: activeTab === "invitereward" ? "#ff0084" : "#fff",
              color: activeTab === "invitereward" ? "#fff" : "red",
            }}
            onClick={() => setActiveTab("invitereward")} // Set active tab to "revenue"
          >
            Revenue
          </Button>
          <Button
            style={{
              width: "45%",
              borderRadius: 0,
              border: "1px solid",
              color: activeTab === "expenditure" ? "#fff" : "#fff",
              fontSize: "14px",
              fontWeight: "700",
              backgroundColor: activeTab === "expenditure" ? "#ff0084" : "#333",
            }}
            onClick={() => setActiveTab("expenditure")} // Set active tab to "expenditure"
          >
            Expenditure
          </Button>
        </Box>

        {/* Show loading spinner if data is being fetched */}
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Box style={{ display: "flex", flexDirection: "column", marginTop: "5px" }}>
            {data?.map((data, ind) => (
              <Box
                sx={{
                  width: "90%",
                  margin: "5px 20px",
                  borderRadius: "12px",
                  backgroundColor: "#fff",
                }}
                key={ind}
              >
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "10px",
                  }}
                >
                  <Box
                    style={{
                      paddingLeft: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 6,
                    }}
                  >
                    <Box
                      style={{
                        background: activeTab === "invitereward" ? "red" : "blue", // Change color based on tab
                        padding: "10px 15px",
                        borderRadius: "10px",
                      }}
                    >
                      <Typography color="#fff">{activeTab === "invitereward" ? "R" : "E"}</Typography>
                    </Box>

                    <Typography
                      style={{
                        color: "#333",
                        fontWeight: "700",
                        fontSize: "20px",
                      }}
                    >{data.reason==="Withdrawal"?'-':'+'}
                      {data.amount}
                    </Typography>
                  </Box>
                  <Box style={{ width: "40%" }}>
                    <Typography color="#333" fontSize={12}>
                      {data.created_at} {data.time}
                    </Typography>
                    <Typography
                      color="#333"
                      style={{ fontSize: "12px", lineHeight: 1 }}
                    >
                      Reason: {data.reason}
                    </Typography>
                    <Typography
                      color="#333"
                      style={{ fontSize: "12px", lineHeight: 1 }}
                    >
                      User Name: {data.giver} {data.username}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
        )}
      </div>
    </>
  );
};

export default DailyStatemant;
